
import { jsonp } from '../assets/js/common.js';
import Scroller from 'vux/src/components/scroller/index.vue'
import Card from 'vux/src/components/card/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Masker from 'vux/src/components/masker/index.vue'


export default {
created() {
jsonp(`/celebrity/${this.$route.params.id}`).then(res => {
this.isLoadMoreShow = false;
this.previewerList = [{
w: 214,
h: 306,
src: res.avatars.large
}];
this.dataList = res;
this.dataList.aka = res.aka.join('、');
this.dataList.aka_en = res.aka_en.join(', ');

setTimeout(() => {
this.$refs.scrollerEvent.reset({ top: 0 });
}, 250);
}).catch(ex => {
console.error(ex);
});
},
updated() {
if (!this.isUpdatedWanted && this.$refs.rightBox) {
this.isUpdatedWanted = true;
var maskerWidth = this.$refs.masker[0].$el.offsetWidth,
imgWidth = this.$refs.imgBox[0].offsetWidth;
this.$refs.rightBox.forEach((elem) => {
elem.style.width = `${(maskerWidth - imgWidth - 20) / 15}rem`;
}, this);
}
},
data() {
return {
dataList: [],
isLoadMoreShow: true,
previewerList: [],
isUpdatedWanted: false,
options: {
getThumbBoundsFn(index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }


}
}
}
},
methods: {

show() {
this.$refs.previewer.show(0);
},

toRoute(id) {
this.$router.push({ path: `/moviedetail/${id}` });
}
},
components: {
Scroller,
Card,
LoadMore,
Previewer,
Divider,
Cell,
Masker
},
directives: {
TransferDom
},
props: ['heightData']
}



// WEBPACK FOOTER //
// ./src/components/MovieCelebrity.vue